const hoverClass = "ux-table__cell--hover";
const rowClass = "ux-table__row--hasFinalForeignRowspanCell";

export const setupRowspanStyles = (table: HTMLTableElement | null) => {
    if (table === null) {
        return;
    }
    setupRowspanHover(table);
    setupRowspanRowClasses(table);
};

/**
 * the last cell of a row is styled differently (no border-right), but when the last cell is a rowspan cell from another row,
 * the last physical cell is not the last visible cell, so we add a class to those rows
 */
const setupRowspanRowClasses = (table: HTMLTableElement) => {
    const rowspanCells = getRowspanCells(table);
    const foreignRowspannedCellsPerRow: boolean[][] = Array.from(table.querySelectorAll("tr")).map((row: HTMLTableRowElement) => {
        return Array.from(row.querySelectorAll("td,th")).map(() => false);
    });
    rowspanCells.forEach(({ rowspan, cell, rowIndex }) => {
        const cellIndex = Array.from(cell.parentElement?.querySelectorAll("td,th") || []).indexOf(cell);
        for (let i = rowIndex + 1; i < rowIndex + rowspan; i++) {
            if (foreignRowspannedCellsPerRow[i]) {
                foreignRowspannedCellsPerRow[i].splice(cellIndex + 1, 0, true);
            }
        }
    });
    foreignRowspannedCellsPerRow.forEach((rowspannedCells, rowIndex) => {
        const lastCellIndex = rowspannedCells.length - 1;
        if (rowspannedCells[lastCellIndex]) {
            table.querySelectorAll("tr")[rowIndex].classList.add(rowClass);
        }
    });
};

const setupRowspanHover = (table: HTMLTableElement) => {
    const rowspanCells = getRowspanCells(table);
    if (rowspanCells.length === 0) {
        return;
    }
    table.querySelectorAll("tr").forEach((row) => {
        row.addEventListener("mouseover", () => {
            const hoverRowIndex = getRowIndex(table, row as HTMLTableRowElement);
            rowspanCells.forEach(({ rowspan, cell, rowIndex }) => {
                if (rowIndex < hoverRowIndex && rowIndex + rowspan > hoverRowIndex) {
                    cell.classList.add(hoverClass);
                }
            });
        });
        row.addEventListener("mouseout", () => {
            rowspanCells.forEach(({ cell }) => {
                cell.classList.remove(hoverClass);
            });
        });
    });
};

const getRowspanCells = (
    table: HTMLTableElement
): {
    rowspan: number;
    cell: HTMLTableCellElement;
    rowIndex: number;
}[] => {
    const cells: HTMLTableCellElement[] = Array.from(table.querySelectorAll("td[rowspan]"));
    return cells
        .map((cell) => {
            const rowspan = parseInt(cell.getAttribute("rowspan") || "1", 10);
            const row: HTMLTableRowElement = cell.parentElement as HTMLTableRowElement;
            const rowIndex = getRowIndex(table, row);
            return { rowspan, cell, rowIndex };
        })
        .filter(({ rowspan, rowIndex }) => rowspan > 1 && rowIndex >= 0);
};

const getRowIndex = (table: HTMLTableElement, row: HTMLTableRowElement): number => {
    return Array.from(table.querySelectorAll("tr")).indexOf(row);
};
